<template>
  <v-tooltip bottom open-delay="100" max-width="400" nudge-bottom="10" transition="slide-y-transition" color="#333">
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        v-on="on"
        right
        size="20"
        :color="color"
        style="cursor: help;"
      >mdi-help-circle</v-icon>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';

export default {
  name: 'HelpTooltip',
  mixins: [
    LocaleUtils
  ],
  props: {
    translationKey: {},
    plainText: {},
    color: {
      default: '#999'
    }
  },
  computed: {
    text () {
      if(this.translationKey) {
        return this.trans(this.translationKey);
      }
      return this.plainText || '';
    },
  }
}
</script>

<style scoped>

</style>
